import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const NoPermissionsTooltipMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: 'editor.options.payment.permissionsTooltip'
});
export default NoPermissionsTooltipMessage;